import { cx } from "@/lib/cx";

/** Spinner is only for pending buttons. Everything else uses row skeletons. */
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cx(
        "inline-block size-3.5 shrink-0 rounded-full border-2 border-current border-t-transparent opacity-80",
        className,
      )}
      style={{ animation: "pt-spin 700ms linear infinite" }}
    />
  );
}
